import { KnownOccupationInfoOccupationType } from '@modules/checkout-store';
import { IAddress } from './address.interface';

export interface IChildEducationDetails {
  occupation?: KnownOccupationInfoOccupationType;
  training?: string;
  education?: string;
  employment?: string;
  address: IAddress;
}
